<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">{{ isCreateGroup ? "Create" : "Edit" }} Group</div>
  <div class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      *ngIf="isCreateGroup"
      mat-button
      color="lightGreen"
      (click)="createNewGroup()"
      [disabled]="userGroupForm.invalid"
    >
      Create Group
    </button>
    <button
      *ngIf="!isCreateGroup"
      mat-button
      color="lightGreen"
      (click)="updateGroup()"
      [disabled]="userGroupForm.invalid"
    >
      Save Group Updates
    </button>
  </div>
</div>

<div class="user-group">
  <div class="containers">
    <div class="container details-container">
      <div class="container-header no-bottom-border">
        <div class="text">Group Details</div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="name"
            placeholder="User Group Name"
            [formGroup]="userGroupForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <div class="members">
            <div class="heading">Members</div>

            <lhpe-option-snack-group>
              <lhpe-option-snack
                *ngFor="let member of userGroup.accountUsers"
                [option]="member"
                [name]="member.name"
                (optionRemoved)="removeMember($event)"
              >
              </lhpe-option-snack>
            </lhpe-option-snack-group>
          </div>
        </div>
      </div>
    </div>

    <div class="container team-members-container">
      <div class="container-header no-bottom-border">
        <div class="text">Team Members</div>
      </div>
      <div class="container-content">
        <div class="rows">
          <div *ngFor="let teamMember of unusedTeamMembers" class="row">
            <div class="name">
              {{ teamMember.name }}
            </div>
            <button mat-icon-button (click)="addMember(teamMember)">
              <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
